var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFcOrdering({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.2 8.5332H12.8C5.54667 8.5332 0 14.0799 0 21.3332V59.7332C0 66.5599 5.54667 72.5332 12.8 72.5332H51.2C58.0267 72.5332 64 66.5599 64 59.7332V21.3332C64 14.0799 58.4533 8.5332 51.2 8.5332ZM59.7333 59.7332C59.7333 64.4265 55.8933 68.2665 51.2 68.2665H12.8C8.10667 68.2665 4.26667 64.4265 4.26667 59.7332V21.3332C4.26667 16.6399 8.10667 12.7999 12.8 12.7999H51.2C55.8933 12.7999 59.7333 16.6399 59.7333 21.3332V59.7332Z",
    fill: "#0088E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9336 38.4004H17.0669C15.7869 38.4004 14.9336 39.2537 14.9336 40.5337C14.9336 41.8137 15.7869 42.6671 17.0669 42.6671H46.9336C48.2136 42.6671 49.0669 41.8137 49.0669 40.5337C49.0669 39.2537 48.2136 38.4004 46.9336 38.4004Z",
    fill: "#0088E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9336 49.0664H17.0669C15.7869 49.0664 14.9336 49.9197 14.9336 51.1997C14.9336 52.4797 15.7869 53.3331 17.0669 53.3331H46.9336C48.2136 53.3331 49.0669 52.4797 49.0669 51.1997C49.0669 49.9197 48.2136 49.0664 46.9336 49.0664Z",
    fill: "#0088E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9336 27.7334H17.0669C15.7869 27.7334 14.9336 28.5867 14.9336 29.8667C14.9336 31.1467 15.7869 32.0001 17.0669 32.0001H46.9336C48.2136 32.0001 49.0669 31.1467 49.0669 29.8667C49.0669 28.5867 48.2136 27.7334 46.9336 27.7334Z",
    fill: "#0088E7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1997 0H19.1997C17.9197 0 17.0664 0.853333 17.0664 2.13333C17.0664 3.41333 17.9197 4.26667 19.1997 4.26667H51.1997C60.5864 4.26667 68.2664 11.9467 68.2664 21.3333V53.3333C68.2664 54.6133 69.1197 55.4667 70.3997 55.4667C71.6797 55.4667 72.5331 54.6133 72.5331 53.3333V21.3333C72.5331 9.38667 63.1464 0 51.1997 0Z",
    fill: "#0088E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFcOrdering);
export default __webpack_public_path__ + "static/media/fc-ordering.8634d2fa5f185b46dc3bf8166a778a59.svg";
export { ForwardRef as ReactComponent };